<script setup lang="ts">
import { computed } from 'vue';
import { useViewComposable } from '@/views/composable';
import Select from 'primevue/select';

interface Props {
  brochure?: any;
}
const props = defineProps<Props>();

const emits = defineEmits<{ 'update:brochure': [value: any] }>();

const { brochureListOption } = useViewComposable();

const brochureData = computed({
  get() {
    return props.brochure;
  },
  set(value) {
    emits('update:brochure', value);
  }
});
</script>

<template>
  <div class="brochure-select">
    <label for="brochure" class="mb-1 inline-block">{{ $t('management.package.brochure') }}</label>
    <Select id="brochure" class="w-full" showClear :placeholder="$t('management.package.select_brochure')" :options="brochureListOption" v-model="brochureData" />
  </div>
</template>
